<div *ngIf="event && !hideEventInfos" id="o-event-infos">
    <div class="name_tags">
        <h1 class="name">{{event.name}}</h1>
        <div class="tags">
            <div class="tag" *ngFor="let category of event.categoriesIds">
                <span>{{category.name}}</span>
            </div>
        </div>
    </div>
    <div class="place_date">
        <div *ngIf="dateString" class="date">
            <svg class="icon icon-date" width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                <path fill="currentColor" d="M17 12h-5v5h5v-5zm2-8h-1V2h-2v2H8V2H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11zm0-13H5V6h14v1z"/>
            </svg>
            {{ dateString }}
        </div>
        <div *ngIf="placeString" class="place">
            <svg class="icon icon-place" width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                <path fill="currentColor" d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
            </svg>
            {{ placeString }}
        </div>
    </div>
</div>
